import {StandaloneState} from './standalone.reducers';

export const getCmcProductsSyncStatus = (state: StandaloneState) => {
  if (state.cmcCollectionsSyncStatus) {
    const newCmcVersion = state.newCmcVersion;
    if(!newCmcVersion) {
      return null;
    }
    return state.cmcCollectionsSyncStatus['fr_cmcproductmanager_products_' + newCmcVersion];
  }
};

export const getCmcClassificationsSyncStatus = (state: StandaloneState) => {
  if (state.cmcCollectionsSyncStatus) {
    const newCmcVersion = state.newCmcVersion;
    if(!newCmcVersion) {
      return null;
    }
    return state.cmcCollectionsSyncStatus['fr_cmcproductmanager_classifications_' + newCmcVersion];
  }
}

export const getNewCmcVersion = (state: StandaloneState) => {
  if (state) {
    return state.newCmcVersion;
  }
}

export const getCurrentCmcVersion = (state: StandaloneState) => {
  if (state) {
    return state.currentCmcVersion;
  }
}

export const getSyncStatus = (state: StandaloneState) => {
  if (state) {
    return state.cmcCollectionsSyncStatus;
  }
}

